import { render } from "./Similars.vue?vue&type=template&id=1ea1fd0e&scoped=true"
import script from "./Similars.vue?vue&type=script&lang=js"
export * from "./Similars.vue?vue&type=script&lang=js"

import "./Similars.vue?vue&type=style&index=0&id=1ea1fd0e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea1fd0e"]])

export default __exports__